const apiBaseURL = 'https://api.ripley.link';

export default apiBaseURL;
